const status = {
  API_VALIDATION_ERROR: [400],
  AUTHENTICATION_ERROR: [401, 403],
  OK: [200, 201, 202, 203, 204, 205, 206, 207, 208],
  SERVICE_DOWN: [404, 500, 502, 503],
}

export default {
  isSuccess: (response) => status.OK.indexOf(response.status) !== -1,
  isValidationError: (response) => status.API_VALIDATION_ERROR.indexOf(response.status) !== -1,
  isAuthenticationError: (response) => status.AUTHENTICATION_ERROR.indexOf(response.status) !== -1,
}



// WEBPACK FOOTER //
// ./src/config/fetch/statusCode.js